module.exports = __webpack_public_path__ + "static/media/sprite2.985bbb24.png";